import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { DefinitionEditorComponent } from "./definition-editor/definition-editor.component";
import { ApiService, Fee, FeeType, IDNameAddress, FeeDTO } from "../../../../../projects/accounting/src/public_api";
import { DecimalPipe } from "@angular/common";
import { Router } from "@angular/router";
import { ApplicationData } from './application/application.component';
import { StorageService } from '../../../../../projects/jv-common/src/public_api';

@Component({
  selector: 'fees',
  templateUrl: './fees.component.html',
  styleUrls: ['./fees.component.scss']
})
export class FeesComponent implements OnInit {

  loading = false;

  private capitals: Array<IDNameAddress> = [];

  private feeTypeLU = {
    Income: {
      name: 'Phí doanh thu',
      class: 'text-primary'
    },
    Periodic: {
      name: 'Phí Định kỳ',
      class: 'text-warning'
    },
    OneTime: {
      name: 'Phí Một lần',
      class: 'text-success'
    },
    Unpredictable: {
      name: 'Phí Phát sinh',
      class: 'text-danger'
    }
  };

  dtConfig = {
    data: [],
    count: false,
    hideTitle: true,
    columns: [
      {
        title: 'Tên',
        class: 'text-left',
        html: i => '<b>' + i.Name + '</b>' + '<br>' + '<small class="text-warning">' + this.description(i) + '</small>',
        css: i => 'text-left text-danger',
        click: i => this.open(i),
      },
      {
        title: 'Loại',
        html: i => '<b>' + this.feeTypeLU[i.Type].name + '</b>',
        css: i => this.feeTypeLU[i.Type].class
      },
      {
        title: 'Mô tả',
        html: function (i) {
          return i.Description;
        }
      },
      {
        title: '',
        html: function (i) {
          return '<i class="fa-pencil fa text-info"></i>'
        },
        css: i => 'text-center text-info',
        click: i => this.edit(i),
      }
    ]
  };

  private timeLU = {
    Day: 'ngày',
    Month: 'tháng',
    Quarter: 'quý',
    Year: 'năm',
  };

  constructor(
    private modal: BsModalService,
    private api: ApiService,
    private decima: DecimalPipe,
    private route: Router,
    private storage: StorageService
  ) {
  }

  ngOnInit() {
    this.load();
  }

  edit(record: FeeDTO = null) {

    let config = {
      class: 'modal-md',
      initialState: {
        data: record == null
          ? null
          : {
            id: record.ID,
            name: record.Name,
            description: record.Description,
            type: record.Type,
            active: record.Active,
            data: record.Data
          }
      }
    };

    this.modal.show(DefinitionEditorComponent, config).content.commit.subscribe(data => {

      this.loading = true;
      if (typeof data.id == 'undefined') {

        let request: FeeDTO = {
          ID: 0,
          Name: data.name,
          Description: data.description,
          Type: data.type,
          Active: data.active,
          Data: data.data
        };

        this.api.feeCreate(request).subscribe(
          response => {

            if (typeof response.succeed && response.data != null) this.dtConfig.data.push(response.data);
            this.loading = false;
          },
          error => { this.loading = false; }
        )
      }
      else {

        let request: FeeDTO = {
          ID: data.id,
          Name: data.name,
          Description: data.description,
          Type: data.type,
          Active: data.active,
          Data: data.data
        };

        this.api.feeUpdate(request).subscribe(
          response => {

            if (typeof response.succeed && response.data) for (let o in request) record[o] = request[o];
            this.loading = false;

          },
          err => { this.loading = false; }
        );
      }
    });
  }

  open(record: FeeDTO) {

    let data: ApplicationData = {
      fee: {
        id: record.ID,
        name: record.Name,
        description: record.Description,
        type: record.Type,
        active: record.Active,
        data: record.Data
      },

      capitals: this.capitals
    };

    if (this.storage.set("/configs/fees/application:input", data)) {
      this.route.navigate(['configs/fees/application']);
    }
  }

  description(record: FeeDTO) {

    switch (record.Type) {
      case 'Income': return +record.Data[0] * 100 + '% tỷ lệ doanh thu';
      case 'Periodic':

        switch (record.Data[3]) {
          case 'Fixed': return this.decima.transform(record.Data[2], '1.0-3', 'en-US') + 'đ/ ' + record.Data[0] + ' ' + this.timeLU[record.Data[1]];
          default: return this.decima.transform(record.Data[2], '1.0-3', 'en-US') + 'đ/ mét vuông/ ' + record.Data[0] + ' ' + this.timeLU[record.Data[1]];
        }

      case 'OneTime': return record.Data[0] == 'Fee' ? 'Phí' : 'Đặt cọc';
      default: return ''
    }
  }

  load() {

    this.loading = true;
    this.api.feeList().subscribe(
      response => {
        if (response.succeed && response.data != null) {

          response.data.Fees.sort((a, b) => a.Type > b.Type ? 1 : -1).forEach(i => this.dtConfig.data.push(i));
          this.capitals = [];
          response.data.Capitals.forEach(i => this.capitals.push({ id: i.ID, name: i.Name, address: i.Address }));
        }

        this.loading = false;
      },

      error => {
        this.loading = false;
      }
    );
  }
}
